<template>
  <v-btn
    :disabled="isMergeButtonDisabled"
    v-on:click="onPressMergeButton"
    class="UXbtn header-btn left-btn"
    outline
    >
    組合わす
  </v-btn>
</template>

<script>
import eventBus from '@/event_bus'
import event from '../../../enums/eventType'

export default {
  props: {
    mergeTargetTicket: Array
  },
  data: () => ({
    isMergeButtonDisabled: true
  }),
  watch: {
    mergeTargetTicket: function (val) {
      this.isMergeButtonDisabled = val.length !== 1
    }
  },
  methods: {
    onPressMergeButton () {
      eventBus.$emit(event.OPEN_TICKET_MERGE_DIALOG)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/button/mergeButton.vue